import BusinessesIcon from 'assets/businesses-logo.svg';
import HandShakeIcon from 'assets/handshake.svg';
import LeadsIcon from 'assets/leads-icon.svg';
import TaskIcon from 'assets/task.svg';
import RoutePaths from 'routes/RoutePaths';

interface ISidebarData {
  title: string;
  path: string;
  icon: string;
  permissionKey?: string;
}

const SidebarData: { main: ISidebarData[]; app: ISidebarData[]; quickLinks: ISidebarData[] } = {
  main: [
    {
      title: 'Dashboard',
      path: RoutePaths.Home,
      icon: '/assets/dashboard-logo.svg',
      permissionKey: 'Dashboard',
    },
    {
      title: 'Client',
      path: RoutePaths.Client,
      icon: '/assets/client.svg',
      permissionKey: 'Client',
    },
    {
      title: 'Team',
      path: RoutePaths.Team,
      icon: '/assets/team.svg',
      permissionKey: 'Teams',
    },
    {
      title: 'Tasks',
      path: RoutePaths.Tasks,
      icon: TaskIcon,
      permissionKey: 'Tasks',
    },
    {
      title: 'Deals',
      path: RoutePaths.Deals,
      icon: HandShakeIcon,
      permissionKey: 'Deals',
    },
    {
      title: 'Leads',
      path: RoutePaths.Leads,
      icon: LeadsIcon,
      permissionKey: 'Leads',
    },
    {
      title: 'Contacts',
      path: RoutePaths.Contacts,
      icon: '/assets/contacts-icon.svg',
      permissionKey: 'Contacts',
    },
    {
      title: 'Businesses',
      path: RoutePaths.Businesses,
      icon: BusinessesIcon,
      permissionKey: 'Businesses',
    },
    {
      title: 'Reports',
      path: RoutePaths.Reports,
      icon: BusinessesIcon,
      permissionKey: 'Reports',
    },
  ],
  app: [
    // {
    //   title: 'Asana',
    //   path: RoutePaths.Asana,
    //   icon: '/assets/asana-logo.png',
    // },
  ],
  quickLinks: [
    {
      title: 'Captiv8',
      path: 'https://captiv8.io/insights/signin',
      icon: '/assets/captiv8-icon.svg',
    },
    {
      title: 'Slack',
      path: `https://slack.com/intl/en-au/signin#/signin`,
      icon: '/assets/slack-nav-icon.svg',
    },
  ],
};

export default SidebarData;
